import { render } from "./Hall9En.vue?vue&type=template&id=a4fcf0b8"
import script from "./Hall9En.vue?vue&type=script&lang=js"
export * from "./Hall9En.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\marco\\Desktop\\archeo-guida-smart\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__